// eslint-disable-next-line import/no-named-as-default -- Todo
import styled from 'styled-components';

export const Canvas = styled.canvas`
  display: block;
  height: 100%;
  width: 100%;
  &:focus {
    outline: none;
  }
`;
